"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.right = exports.left = exports.top = exports.bottom = exports.getArrowByPlacement = void 0;
var ArrowRight_svg_1 = require("../../assets/icons/ArrowRight.svg");
Object.defineProperty(exports, "right", { enumerable: true, get: function () { return ArrowRight_svg_1.ReactComponent; } });
var ArrowLeft_svg_1 = require("../../assets/icons/ArrowLeft.svg");
Object.defineProperty(exports, "left", { enumerable: true, get: function () { return ArrowLeft_svg_1.ReactComponent; } });
var ArrowTop_svg_1 = require("../../assets/icons/ArrowTop.svg");
Object.defineProperty(exports, "top", { enumerable: true, get: function () { return ArrowTop_svg_1.ReactComponent; } });
var ArrowBottom_svg_1 = require("../../assets/icons/ArrowBottom.svg");
Object.defineProperty(exports, "bottom", { enumerable: true, get: function () { return ArrowBottom_svg_1.ReactComponent; } });
function getArrowByPlacement(placement) {
    if (placement.indexOf('top') === 0) {
        return ArrowTop_svg_1.ReactComponent;
    }
    if (placement.indexOf('bottom') === 0) {
        return ArrowBottom_svg_1.ReactComponent;
    }
    if (placement.indexOf('left') === 0) {
        return ArrowLeft_svg_1.ReactComponent;
    }
    if (placement.indexOf('right') === 0) {
        return ArrowRight_svg_1.ReactComponent;
    }
}
exports.getArrowByPlacement = getArrowByPlacement;
//# sourceMappingURL=Arrows.js.map